import type { Room } from "@/models";
import type { CustomGuestCallOptionsRoom } from "../../../../models/room/room.model";
import type { RoomDTO } from "../dtos";
import type { CustomGuestCallOptionsRoomDTO } from "../dtos/room.api.dto";

export const mapRoomDTO = (roomDetailsDTO: RoomDTO): Room => {
  return {
    hubspotId: roomDetailsDTO?.hubspotId,
    name: roomDetailsDTO?.name,
    voiceName: roomDetailsDTO?.voiceName || "",
    noiseSettings: {
      low: roomDetailsDTO?.noiseSettings?.low,
      medium: roomDetailsDTO?.noiseSettings?.medium,
      high: roomDetailsDTO?.noiseSettings?.high,
    },
    location: {
      lat: roomDetailsDTO?.location?.lat,
      lng: roomDetailsDTO?.location?.lng,
    },
    address: roomDetailsDTO?.address,
    phone: roomDetailsDTO?.phone,
    phoneSMS: roomDetailsDTO?.phoneSMS,
    timezone: {
      name: roomDetailsDTO?.timezone?.name,
      label: roomDetailsDTO?.timezone?.label,
    },
    licenseId: roomDetailsDTO?.licenseId,
    serviceContractId: roomDetailsDTO?.serviceContractId,
    _id: roomDetailsDTO?._id,
    monitor: roomDetailsDTO.monitor ?? false,
    username: roomDetailsDTO.username,
    ownerId: roomDetailsDTO.ownerId,
    managerId: roomDetailsDTO.managerId,
    address2: roomDetailsDTO.address2,
    zipCode: roomDetailsDTO.zipCode,
    city: roomDetailsDTO.city,
    province: roomDetailsDTO.province,
    country: roomDetailsDTO.country,
    nightAgent: roomDetailsDTO.nightAgent ?? false,
    lockNoiseNotifications: roomDetailsDTO.lockNoiseNotifications ?? false,
    callsEnabled: roomDetailsDTO.callsEnabled ?? false,
    muteAlarmNotifications: roomDetailsDTO.muteAlarmNotifications ?? false,
    sendNoiseMailNotification: roomDetailsDTO.sendNoiseMailNotification ?? false,
    sendNoisePushNotification: roomDetailsDTO.sendNoisePushNotification ?? false,
    disconnectionNotificationEnabled: roomDetailsDTO.disconnectionNotificationEnabled ?? false,
    disableFirstCall: roomDetailsDTO.disableFirstCall ?? false,
    callAllTime: roomDetailsDTO.callAllTime ?? false,
    alarms: roomDetailsDTO.alarms,
    customGuestCallOptions: mapCustomGuestCallOptionsDTO(roomDetailsDTO.customGuestCallOptions),
    microphoneSensibility: roomDetailsDTO.microphoneSensibility,
    sendSmokeSMSNotification: roomDetailsDTO.sendSmokeSMSNotification,
    sendSmokeMailNotification: roomDetailsDTO.sendSmokeMailNotification,
    sendSmokePushNotification: roomDetailsDTO.sendSmokePushNotification ?? false,
    sendNoiseSMSNotification: roomDetailsDTO.sendNoiseSMSNotification,
    sendSMSToAll: roomDetailsDTO.sendSMSToAll ?? false,
    smokingAlertThreshold: roomDetailsDTO.smokingAlertThreshold,
    crowdingAlertTreshold: roomDetailsDTO.crowdingAlertTreshold,
    sendCrowdMailNotification: roomDetailsDTO.sendCrowdMailNotification,
    sendCrowdSMSNotification: roomDetailsDTO.sendCrowdSMSNotification,
    sendCrowdPushNotification: roomDetailsDTO.sendCrowdPushNotification ?? false,
    guestyLinkedRoom: roomDetailsDTO.guestyLinkedRoom,
    avantioLinkedRoom: roomDetailsDTO.avantioLinkedRoom,
    krossLinkedRoom: roomDetailsDTO.krossLinkedRoom,
    hostifyLinkedListing: roomDetailsDTO.hostifyLinkedListing,
    hostawayLinkedListing: roomDetailsDTO.hostawayLinkedListing,
    rentalreadyLinkedRental: roomDetailsDTO.rentalreadyLinkedRental,
    icneaLinkedProperty: roomDetailsDTO.icneaLinkedProperty,
    alertSchedules: roomDetailsDTO.alertSchedules || [],
    batteryCapacity: roomDetailsDTO.batteryCapacity,
    mergeDone: roomDetailsDTO.mergeDone || false,
    licenses: roomDetailsDTO.licenses || [],
    devices: roomDetailsDTO.devices?.map((device) => ({
      monitorId: device.monitorId,
      location: device.location,
      firmware: device.firmware,
      connected: device.connected,
      synchronizedAt: device.synchronizedAt,
      alarms_enabled: device.alarms_enabled,
      data: device.data
        ? {
            level: device.data.level,
            value: device.data.value,
            updatedAt: device.data.updatedAt ?? 0,
            wifi: device.data.wifi,
            quality: device.data.quality,
            localip: device.data.localip,
            batteryLevel: device.data.batteryLevel,
            batteryMode: device.data.batteryMode,
          }
        : undefined,
    })),
  };
};

const mapCustomGuestCallOptionsDTO = (
  customGuestCallOptionsDTO?: CustomGuestCallOptionsRoomDTO
): CustomGuestCallOptionsRoom => {
  if (!customGuestCallOptionsDTO) {
    return {
      EN: "",
      PT: "",
      ES: "",
      FR: "",
    };
  }
  return {
    EN: customGuestCallOptionsDTO.EN || "",
    PT: customGuestCallOptionsDTO.PT || "",
    ES: customGuestCallOptionsDTO.ES || "",
    FR: customGuestCallOptionsDTO.FR || "",
  };
};
